import { ProductPageLayout } from '../components/ProductPageLayout';

export function AiInfluencerCharacterMatchingPage() {
    return <ProductPageLayout productId="ai-influencer-character-matching" />;
}
